import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { DeviceModel } from '../../models/device.model';
import { v4 as uuidv4 } from 'uuid';
//import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AppearanceService } from '../appearance/appearance.service';
//import { DeviceDetectorService } from 'ngx-device-detector';
import { APIService } from '../api/api.service'
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DeviceService 
{
  currentDevice: DeviceModel;


  constructor(private localStorageService: LocalStorageService, private appearanceService: AppearanceService,
    private apiService: APIService) 
  { 
    this.initService();
  }


  initService()
  {
    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
    this.currentDevice = this.localStorageService.getDevice();
   
    if (!this.currentDevice)
    {
      this.currentDevice = new DeviceModel();
      
      if (this.appearanceService.isMobileDevice())
      {
        //var mobileUuid = this.device.uuid;
        //this.currentDevice.deviceUuid = mobileUuid;
        //this.localStorageService.saveDeviceUuid(mobileUuid);
      }
      else
      {
        var browserUuid = uuidv4();
        this.currentDevice.deviceUuid = browserUuid;
        this.localStorageService.saveDeviceUuid(browserUuid);
      }
    }

    if (this.appearanceService.isMobileDevice())
    {
      this.setMobileDetails();
    }
    else
    {
      this.setBrowserDetails();
    }

    this.localStorageService.saveDevice(this.currentDevice);
  }


  setBrowserDetails()
  {
    /*
    var browserInfo = this.deviceDtctService.getDeviceInfo();

    if (browserInfo.device == "Unknown")
    {
      this.currentDevice.deviceModel = browserInfo.browser;
    }
    else
    {
      this.currentDevice.deviceModel = browserInfo.device;
    }
    
    this.currentDevice.deviceType = browserInfo.os;
    this.currentDevice.deviceOs = browserInfo.os_version;
    */
  }


  setMobileDetails()
  {
    /*
    this.currentDevice.deviceModel = this.device.model;
    this.currentDevice.deviceType = this.device.platform;
    this.currentDevice.deviceOs = this.device.version;
    */
  }

  public logout() 
  {
    //this.currentDevice = null;
    //this.localStorageService.saveDevice(this.currentDevice);
  }

  public deleteDevice(deviceUid, clientUid, organisationUid): any 
  { 
    var payload = {
      clientUid: clientUid,
      organisationUid: organisationUid,
      deviceUid: deviceUid
    }

    return this.apiService.deleteDevice(payload).pipe(map((response: any) => {

      if (response.Success)
      {

      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  // Getters -------------------------------------------------------------------------

  public getDeviceDetails(uid, clientUid, organisationUid): any 
  { 
    var payload = {
      deviceUid: uid,
      clientUid: clientUid,
      organisationUid: organisationUid
    }

    return this.apiService.getDeviceDetails(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  public getDeviceUuid(): string
  {
    if (this.currentDevice)
    {
      return this.currentDevice.deviceUuid;
    }

    if (this.appearanceService.isMobileDevice())
    {
      this.currentDevice = new DeviceModel();
      //var mobileUuid = this.device.uuid;
      //this.currentDevice.deviceUuid = mobileUuid;
      //this.localStorageService.saveDeviceUuid(mobileUuid);
    }
    else
    {
      this.currentDevice = new DeviceModel();
      var browserUuid = uuidv4();
      this.currentDevice.deviceUuid = browserUuid;
      
      this.localStorageService.saveDeviceUuid(browserUuid);
    }

    return this.currentDevice.deviceUuid;
  }


  public updateDeviceUid(deviceUid)
  {
    this.currentDevice.deviceUid = deviceUid;
    this.localStorageService.saveDevice(this.currentDevice);
  }


  public getCurrentDevice(): DeviceModel
  {
    return this.currentDevice;
  }


  public getDeviceUid(): number
  {
    if (this.currentDevice)
    {
      if (this.currentDevice.deviceUid)
      {
        return this.currentDevice.deviceUid;
      }
    }

    return -1
  }


  public getDeviceModel(): string
  {
    if (this.currentDevice)
    {
      if (this.currentDevice.deviceModel)
      {
        return this.currentDevice.deviceModel;
      }
    }

    return null
  }


  public getDeviceType(): string
  {
    if (this.currentDevice)
    {
      if (this.currentDevice.deviceType)
      {
        return this.currentDevice.deviceType;
      }
    }

    return null
  }


  public getDeviceOs(): string
  {
    if (this.currentDevice)
    {
      if (this.currentDevice.deviceOs)
      {
        return this.currentDevice.deviceOs;
      }
    }

    return null
  }


  public isDeviceLoggedIn(): boolean
  {
    if (this.currentDevice)
    {
      if (this.currentDevice.deviceUid)
      {
        return true;
      }
    }

    return false;
  }
}
